module.exports = __webpack_public_path__ + "static/amanat-banner-0346c6169370ef922da1db183b3e8ba3.jpg";